import React from "react";
import Card from "react-bootstrap/Card";
import Topbar from "../../components/Topbar";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import Nebula from "../../images/Nebula.jpg";
import Noise from "../../images/Noise.png";
import Pineapples from "../../images/Pineapples.png";
import TxtToImg from "../../components/Generator/TxtToImg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// First lesson, introduces students to Stable Diffusion, briefly
// explains how it works, then allows the student to try out
// text-to-image generation by embedding the TxtToImg component
// in the page.

class FirstLesson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Introduction to Stable Diffusion",
      length: "30 minutes",
      description:
        "This lesson will cover the basics of Stable Diffusion and its key concepts.",
      topics: [
        "Image Generation",
        "Stable Diffusion Introduction",
        "Introduction",
      ],
      page: "../lessons/first",
    };
  }

  render() {
    return (
      <div className="lesson" style={{ backgroundColor: "#727c8f" }}>
        <Topbar />

        <div className="d-flex justify-content-center">
          <Card>
            <Card.Header className="bg-success text-white text-center">
              <h3>{this.state.title}</h3>
            </Card.Header>
            <Card.Body style={{ maxWidth: "75vw" }}>
              <div className="text-center">
                <Card.Title>Lesson Length: {this.state.length}</Card.Title>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="text-center">
                <Image src={Nebula} width="25%" height="25%" />
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Hello, and welcome to an introduction to Stable Diffusion, an
                  extremely powerful piece of software that we will use to
                  create a new image just from a bit of text.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Stable Diffusion is a machine learning model, which means that
                  it uses artificial intelligence to create an image from
                  whatever sentence or phrase you type in. By using the text
                  prompt entered in by you, it will find an image in its
                  database or place where computer data is stored.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  It does this by comparing tags or captions that input images
                  have with the text prompt you entered in. This method is very
                  reliable but how does it create an image and how does it know
                  it's correct?
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Stable Diffusion creates images by taking in a large number of
                  images from the internet followed by adding and removing noise
                  (random pixels or the colorful squares in the images below):
                </Card.Text>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <div className="text-center">
                  <Image src={Noise} width="75%" height="75%" />
                  {/* Source: https://pub.towardsai.net/latent-diffusion-models-the-architecture-behind-stable-diffusion-434ba7d91108 */}
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  As you can see from the example above, the random colors
                  change what is shown in an input image.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  The output image is created from predicting what the removal
                  of the noise will look like. This creates unique images from
                  inputs that the artificial intelligence can spit out.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  The AI does not actually know if the image is correct but that
                  is why it is considered a deep learning model. It is learning
                  from repetitive image creation in order to produce a better
                  image the next time.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Now that we know how Stable Diffusion creates an image, we can
                  create our own using the image generation tool below.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Below you will see a text box along with a generate image
                  button. For this example, we will be creating an image using
                  the prompt: 'pineapple shaped car'.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  This will give us a good idea as to how to create an image as
                  well as showing the reliability of the images that Stable
                  Diffusion produces. Go ahead and click on the 'Generate'
                  button.
                </Card.Text>
              </div>
              <Container fluid>
                <Row>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                  <Col md={{ span: 8, offset: 0 }}>
                    <br />
                    <TxtToImg />
                    <br />
                  </Col>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                </Row>
              </Container>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-center">
                  Below is our generation of a 'pineapple shaped car' four
                  times:
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <div className="text-center">
                  <Image src={Pineapples} width="75%" height="75%" />
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Above you will see a set of four images that were created with
                  Stable Diffusion. Of these four images, it is quite clear that
                  while the artificial intelligence understood the prompt, it
                  did not perfectly recreate the prompt.
                </Card.Text>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  The first two images could be considered cars with pineapple
                  aesthetics, the third could be what we are looking for but the
                  image is cut off, and the fourth one just has pineapple shaped
                  wheels
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Now, these four images do a great job of showing how this
                  process is not perfect and why learning is important for an
                  artificial intelligence to improve itself.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  You may have even noticed that generating images on your end
                  generated different images than our example. This is expected
                  since Stable Diffusion is creating new images every time. You
                  can try this out yourself by generating again.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Now, go ahead and create your own image from something you
                  just came up with. You will have finished your first lesson
                  when you are done generating images.
                </Card.Text>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div
                style={{
                  fontSize: "4.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">Congratulations!</div>
              </div>
              <div
                style={{
                  fontSize: "2.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">
                  You have completed your first lesson in Diffractive!
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="d-flex justify-content-center">
                <Nav>
                  <Nav.Link id="FirstReturn" href="../lessons" variant="dark">
                    <Button variant="info">Return to Lessons</Button>
                  </Nav.Link>
                </Nav>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default FirstLesson;
